export function getPaginationFromQuery(query: {
  take?: string;
  skip?: string;
}) {
  return {
    take: query.take ? parseInt(query.take) : 50,
    skip: query.skip ? parseInt(query.skip) : 0,
  };
}
